import React from 'react'

const HeatAirConditioning = ({ width = '64px', height = '64px', color }) => (
  <svg version={1.1} id="Layer_1" x="0" y="0" viewBox="0 0 512 512" xmlSpace="preserve" width={width} height={height}>
    <path
      fill="none"
      stroke={color}
      strokeWidth={20}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M258.6 256.043h191.71M115.835 116.07l66.009 66.009M57.724 255.722h91.295M116.759 394.661l63.776-63.776M439.024 307.637l-51.535-51.535 49.859-49.858M256.937 257.549l134.825 134.825M349.081 419.415v-68.881h69.93M256.92 251.213v191.824M258.653 385.278l54.398 54.398M256.92 254.709V61.966M309.886 75.137l-51.534 51.534M256.902 255.977l134.895-134.895M420.27 165.625h-72.881v-70.93M253.994 151.796c-57.646 3.394-103.297 49.038-103.297 104.846 0 55.901 45.803 101.603 103.584 104.863"
    />
  </svg>
)
export default HeatAirConditioning
